<template>
  <div>
    <div class="pageLogin">
      <div class="box-card">
        <div class="box-list">
          <div class="box-car-title">
            <div class="title1">{{ $i18n.locale == "en" ? 'Member Login' : $i18n.locale == "zh" ? '登录' : 'تسجيل الدخول' }}</div>
            <div class="title2">
              <el-select v-model="language" @change="changeLanguage">
                <el-option
                  style="display: flex; align-items: center"
                  v-for="(item, index) in filterOptions"
                  :key="index"
                  :value="item.name"
                >
                  <img :src="item.src" :alt="item.name" style="width: 18px; height: 12px; margin-right: 5px" />
                  <span style="font-size: 12px">{{ item.name }}</span>
                </el-option>
              </el-select>
            </div>
          </div>
          <div>
            <el-form :model="form" ref="form" label-position="top" label-width="170px" :rules="rules">
              <el-form-item prop="userAccount" :label="$t('useraccount') + ':'">
                <template #error>
                  <div class="erro">{{ $t("inputUserAccount") }}</div>
                </template>
                <el-input v-model="form.userAccount" style="width: 440px;"></el-input>
              </el-form-item>
              <el-form-item prop="userPassword" :label="$t('password') + ':'">
                <template #error>
                  <div class="erro">{{ $t("inputPassword") }}</div>
                </template>
                <el-input type="password" v-model="form.userPassword" style="width: 440px;"></el-input>
              </el-form-item>
              <el-form-item prop="valideCode" :label="$t('vaildecode') + ':'" class="valide-code">
                <template #error>
                  <div class="erro">{{ $t("inputVaildeCode") }}</div>
                </template>
                <el-input v-model="form.valideCode" style="width: 440px;"></el-input>
                <img
                  v-if="JSON.stringify(codeData) !== '{}'"
                  @click="getCode"
                  :src="codeData.valideCode"
                  title="看不清楚？换一张"
                  style="border: 1px solid gainsboro;"
                />
              </el-form-item>
            </el-form>
          </div>
          <el-button type="primary" @click="submit" class="btn">{{ $t('login') }}</el-button>
          <div class="Registration" @click="toRegister">{{ $t("toregister") }}</div>
        </div>
      </div>
    </div>
    <div style="height: 50px;"></div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { GetValideCode, LoginMember } from '@/api/login'
import { setDocumentTitle } from '@/utils/domUtil'

export default {
  name: 'loginModal',
  data() {
    return {
      options: [
        { name: "English", value: "en", src: require("@/assets/English.png") },
        { name: "中文", value: "zh-Hans", src: require("@/assets/China.png") },
        // {
        //   name: "русский язык",
        //   value: "ru",
        //   src: require("@/assets/Russia.png"),
        // },
        {
          name: "الصينية",
          value: "ru",
          src: require("@/assets/alibo.jpg"),
        },
      ],
      language: this.$t("language"),
      languageIcon: require("@/assets/English.png"),
      visible: false,
      codeData: {},
      form: {
        userAccount: '',
        userPassword: '',
        valideCode: ''
      },
      rules: {
        userAccount: [
          {
            required: true,
            message: this.$t('inputUserAccount'),
            trigger: 'blur'
          }
        ],
        userPassword: [
          {
            required: true,
            message: this.$t('inputPassword'),
            trigger: 'blur'
          },
          { min: 6, message: this.$t('passwordLength'), trigger: 'blur' }
        ],
        valideCode: [
          {
            required: true,
            message: this.$t('inputVaildeCode'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  watch: {
    currentLanguage() {
      this.language = this.$t("language")
    }
  },
  computed: {
    ...mapState('operate', ['language']),
    filterOptions() {
      let list = ['en', 'zh-Hans', 'ru'];
      let newList = this.options.filter((item) => list.includes(item.value));
      return newList;
    },
    activeIcon() {
      return this.$t("language") == "English"
        ? this.options[0].src
        : this.$t("language") == "中文"
          ? this.options[1].src
          : this.options[2].src;
    },
    currentLanguage() {
      return this.$t("language")  // 获取当前语言
    }
  },
  mounted() {
    this.getCode()
  },
  methods: {
    changeLanguage(e) {
      if (e === "English") {
        this.$i18n.locale = "en";
        this.set_language("en");
        this.languageIcon = this.options[0].src;
        setDocumentTitle(this.getSetting.enTitle);
        // window.location.reload()
      } else if (e === "中文") {
        this.$i18n.locale = "zh";
        this.set_language("zh");
        this.languageIcon = this.options[1].src;
        setDocumentTitle(this.getSetting.title);
        // window.location.reload()
      } else if (e === "русский язык") {
        this.$i18n.locale = "ru";
        this.set_language("ru");
        this.languageIcon = this.options[2].src;
        setDocumentTitle(this.getSetting.rusTitle);
      } else if (e === "الصينية") {
        this.$i18n.locale = "ru";
        this.set_language("ru");
        this.languageIcon = this.options[2].src;
        setDocumentTitle(this.getSetting.rusTitle);
      }
    },
    ...mapActions('user', ['set_userInfo']),
    ...mapActions("operate", {
      set_language: "set_language",
    }),
    open() {
      this.visible = true
    },
    close() {
      this.visible = false
      this.$refs.form.resetFields()
    },
    // 提交
    submit() {
      let _this = this
      this.$refs.form.validate(values => {
        if (!values) return false
        LoginMember({ ...this.form, keyCode: this.codeData.keyCode })
          .then(res => {
            if (res.success) {
              console.log(res)
              _this.set_userInfo(res.data)
              _this.$message.success(_this.$t('loginSuccess'))
              //window.location.reload() // 强刷界面
              _this.$router.push("/home")
            }
          })
          .catch(err => {
            if (err.includes('D1632') || err.includes('D1631')) {
              _this.$message.error(_this.$t('CodeError'))
            } else if (err.includes('D1629')) {
              _this.$message.error(_this.$t('notreviewed'))
            } else if (err.includes('D1628')) {
              _this.form.userPassword = ''
              _this.$message.error(_this.$t('loginError'))
            }
            _this.getCode()
          })
      })
    },
    // 获取图形验证码
    getCode() {
      GetValideCode()
        .then(res => {
          this.codeData = res.data
        })
        .catch(err => {
          this.$message.error(err)
        })
    },
    // 去注册
    toRegister() {
      this.$router.push("/regPage")
    }
  }
}
</script>

<style lang="scss" scoped>
.pageLogin {
  height: calc(100vh - 271px);
  display: flex;
  justify-content: center;
  background-color: #ffffff;
  background: url('../../assets/tianshi/createbj.jpg') 100% 100%;
  .box-card {
    width: 500px;
    height: 600px;
    margin-top: 73px;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0px 3px 20px 0px rgba(0, 0, 0, 0.06);
    display: flex;
    align-items: flex-start;
    justify-content: center;
    .box-list {
      width: 440px;
      margin-top: 47px;
    }
    .box-car-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 40px;
      .title1 {
        font-size: 24px;
        font-weight: 500;
        color: #222222;
      }
      .title2 {
        font-size: 14px;
        font-weight: 400;
        color: #b2b2b2;
      }
      :deep(.el-input__inner) {
        font-size: 14px;
        width: 95px;
        border: none;
        background-color: #ffffff;
      }
    }
  }
}

:deep .el-form {
  .valide-code {
    .el-input {
      margin: 0 10px 0 0;
    }
    .el-form-item__content {
      display: flex;
    }
  }
  .el-form-item {
    margin-bottom: 0px !important;
  }
}

:deep .el-form--label-top .el-form-item__label {
  padding: 0px !important;
}

.Registration {
  text-align: center;
  cursor: pointer;

  &:hover {
    color: #d871b8;
  }
}

button {
  width: 300px;
  background-color: #d871b8;
  border-color: #d871b8;

  &:hover {
    background-color: #d871b8;
    border-color: #d871b8;
  }
}

// display: flex;
.btn {
  margin-bottom: 20px;
  width: 440px;
  height: 42px;
  background: #d871b8;
  border: 1px solid #d871b8;
  margin-top: 40px;
}
.erro {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
  position: absolute;
  top: 100%;
  left: 0;
}
</style>